
























import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class Slider extends Vue {
  @Prop() type!: string;

  @Prop() range!: string;

  value: string = this.range;

  @Watch('range')
  @Watch('value')
  emitChange(newV: string, old: string) {
    if (this.range === this.value) {
      return;
    }
    this.value = newV;
    this.$emit('value-change', newV);
  }

  get inputId(): string {
    return `${this.type.toLowerCase()}-range`;
  }

  get max(): number {
    if (this.type === 'Hue') {
      return 360;
    }
    return 100;
  }
}
